import classNames from 'classnames';

import SectionTitle from '../SectionTitle/SectionTitle';
import BundlesTable from './BundlesTable';
import Mounthly from './Mounthly';

import styles from './Bundles.module.scss';

const Bundles = ({ data, className, handleConnect = () => null }) => {
  return (
    <section
      className={classNames(styles.bundles, className)}
      itemScope
      itemType='https://schema.org/OfferCatalog'
    >
      {data?.title && (
        <SectionTitle
          titleModify={classNames(styles.bundles__title, 'title--large')}
        >
          {data.title}
        </SectionTitle>
      )}
      <div className={styles.bundles__inner}>
        <BundlesTable data={data} />
        <Mounthly handleConnect={handleConnect} data={data} />
      </div>
    </section>
  );
};

export default Bundles;
